import React from 'react'
import styled from 'styled-components'
import { Loading } from '../UI/Loading'
import { colors } from '../../styles/colors'

import logo from '../../img/logo.png'

const Container = styled.div`
    width: 100vw;
    height: 100vh;

    positon: relative;
    overflow: hidden;

    background: ${colors.dark_blue};

    .background-rectangle {
        background: ${colors.white};
        
        position: absolute;
        left: -373px;
        top: -110px;  
        z-index: 1;
        transform: rotate(-45deg);

        transition: all .5s;

        @media (min-width: 1440px) and (max-width: 1919.98px) {
            left: -473px;
            top: -160px;  
        }
        @media (min-width: 768px) and (max-width: 1439.98px) {
            left: -473px;
            top: -160px;  
        }
        @media (min-width: 768px) {
            width: 995px;
            height: 538px;
        }
        @media (max-width: 767.98px) {
            width: 500px;
            height: 300px;

            left: -200px;
            top: -90px;
        }
    }
    .logo {
        width: 100px;
        height: 100px;

        position: absolute;
        top: 18rem;
        left: 18rem;
        z-index: 2;

        background: url(${logo}) no-repeat 50% 50% ;
        background-size: cover;

        transition: all .5s;

        @media (min-width: 768px) and (max-width: 1919.98px) {
            top: 13rem;
            left: 13rem;  
        }
        @media (max-width: 767.98px) {
            top: 5rem;
            left: 5rem;
        }
    }
    .preloader {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`

export const LoadingPage = () => {
    return (
        <Container>
            <div className="background-rectangle" />
            <div className="logo" />
            <Loading lighten />
        </Container>
    )
}
